import { useCallback } from 'react';
import { SEARCH_DETAILS_ORDERING_KEY } from '@/app/(main)/search-details/consts/search-details';
import { useSearchQuery } from '@/hooks/useSearchQuery';

export const useSorting = () => {
  const [query, updateQuery] = useSearchQuery();

  const onSortingChange = useCallback(
    (sortField: string) => {
      const ordering = query.get(SEARCH_DETAILS_ORDERING_KEY) || '';
      const sort = !ordering ? sortField : ordering.includes('-') ? null : `-${sortField}`;

      updateQuery({ [SEARCH_DETAILS_ORDERING_KEY]: sort });
    },
    [updateQuery, query]
  );

  return { onSortingChange };
};
